export default {
      id: "icon-masque-usage",
      viewBox: "0 0 75.5 74.1",
      url: __webpack_public_path__ + "icons.svg#icon-masque",
      toString: function () {
        return this.url;
      }
    }